import { css } from "@emotion/css";

export const pointerCss = css({
  cursor: 'pointer',
});